import { render } from "./WindowSettings.vue?vue&type=template&id=7a2f021b&scoped=true"
import script from "./WindowSettings.vue?vue&type=script&lang=js"
export * from "./WindowSettings.vue?vue&type=script&lang=js"

import "./WindowSettings.vue?vue&type=style&index=0&id=7a2f021b&scoped=true&lang=css"
import "./WindowSettings.vue?vue&type=style&index=1&id=7a2f021b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2f021b"]])

export default __exports__